<template lang="pug">
.rcm
  slider.rcmCardBlock(v-if="specialArticles !== null")
    slideritem.card(
      v-for="item in specialArticles" :key="item.id"
    )
      a.rcmCard(
        :href="item.url" 
        target="bank"
      )
        ImgLoader.img(
          :img="item.cover_photo" 
          :alt="'沒有圖片'"
          :style="{'--bgPos': 'center'}"
        )       
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
  props: {
    specialArticles: {
      type: Array,
      default: () => []
    },
    postData: {},
    project_data: {}
  },
  components: {
    slider,
    slideritem
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'

.rcm
  width: 95%
  height: 60vw
  box-sizing: border-box
  // +bb
  +phone
    height: 80vw
  .slider-touch
    +pad
      height: 90%
    +phone
      height: 100%
  .swiper-container-horizontal>*>.slider-pagination-bullet
    +pad
      width: 2vw
      height: 2vw
  .swiper-container-horizontal .slider-pagination-bullet-active, .swiper-container-vertical .slider-pagination-bullet-active
    background-color: black !important
  .swiper-container-horizontal>.slider-pagination-bullets
    bottom: 1px !important
    +pad
      // bottom: px !important
      // bottom: -30px !important

      
    +phone
      // height: 50vw
      bottom: -3px !important
    
  .rcmCardBlock
    .card
      width: 80%
      .rcmCard
        width: 100%
        height: 90%
        // +bb
        margin-left: 4%
        +phone
          height: 85%
        .img
          width: 100%
          height: 100%
      
</style>


// WEBPACK FOOTER //
// src/components/RCardM.vue